// extracted by mini-css-extract-plugin
export default {"container":"ActionFooter-module__container-tGMgjk","row":"ActionFooter-module__row-jiHK_l","action":"ActionFooter-module__action-xXADzW","link":"ActionFooter-module__link-G44FFo"};